import { Component, OnInit } from '@angular/core';
import { EvaluationService } from 'src/app/services/evaluation/evaluation.service';
import { Vendordata } from 'src/app/model/vendordata.model';
import { ActivatedRoute, Router } from '@angular/router';
import { DataSharingService } from 'src/app/auth/data-sharing.service';
import { Createproject } from 'src/app/model/createproject.model';
import { Vendorregistration } from 'src/app/model/vendorregistration.model';
import { UserService } from 'src/app/services/user/user.service';
import { Searchgeneral } from 'src/app/model/searchgeneral.model';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { RoleService } from 'src/app/services/role/role.service';
import * as XLSX from 'xlsx';


@Component({
  selector: 'app-assignsurveylink',
  templateUrl: './assignsurveylink.component.html',
  styleUrls: ['./assignsurveylink.component.css']
})
export class AssignsurveylinkComponent implements OnInit {
  data: any;
  fileName: any;
  file: any;
  arrayBuffer: any;
  multipleSurveyLink: string;
  filelist: any;
  single: boolean = false;
  multiple: boolean = false;
  linkBool: boolean = true;
  uploadFileBool: boolean = false;
  isListLoading: boolean = false;
  textBoxBoolForSingleMultiple: boolean = false;
  projectDetails: any;
  showDataBool: boolean = false;
  dataL: any;
  countryData: any;
  languageData: any;
  evaluationDataAny: any;
  excelDataNumber: number;
  localUrl: string;
  vendreg: Vendorregistration;
  setBool: boolean = false;
  searchGeneral: Searchgeneral;
  projectid: string;
  langid: string;
  countryid: string;
  textBoxBool: boolean = false;
  optimisticcount: number;
  target: number;
  singleBool: boolean = false;
  isLoading : boolean = false;
  constructor(private router: Router, private route: ActivatedRoute, private toastr: ToastrService, private roleservice: RoleService, private userService: UserService, private evaluationService: EvaluationService, private dataSharingService: DataSharingService) {
    this.projectid = this.route.snapshot.params.projectid;
    this.countryid = this.route.snapshot.params.countryid;
    this.langid = this.route.snapshot.params.langid;
    this.target = this.route.snapshot.params.target;
    this.optimisticcount = this.route.snapshot.params.opcount;
  }

  ngOnInit() {
    this.textBoxBool = true;
    this.textBoxBoolForSingleMultiple = true;
    this.vendreg = new Vendorregistration();
    this.searchGeneral = new Searchgeneral();
    this.getCountryList();
    this.getLanguageList();

    if (this.projectid != undefined) {
      this.textBoxBoolForSingleMultiple = true;
      this.textBoxBool = false;
      this.roleservice.SearchProjectInfoDetails(this.projectid).subscribe(
        (data: any) => {
          this.projectDetails = data;
          if (this.projectDetails.length === 0) {
            this.showDataBool = false;
            this.toastr.error("No items found", '', { progressBar: true });
          }
          else {
            this.showDataBool = true;
            if (this.projectDetails[0].clintLinkType) {
              this.vendreg.single = this.projectDetails[0].clintLinkType.toLowerCase();
              this.vendreg.multiple = this.projectDetails[0].clintLinkType.toLowerCase();
              this.singleBool = true;
              this.uploadFileBool = this.projectDetails[0].clintLinkType.toLowerCase() == "single" ? false : true;
              this.linkBool = this.projectDetails[0].clintLinkType.toLowerCase() == "single" ? true : false;
            }
            else {
              this.vendreg.single = "single";
              this.vendreg.multiple = "single";
            }

          }
          console.log(this.projectDetails);
        }
      )
      this.vendreg.country = this.countryid;
      this.vendreg.language = this.langid;
    }
  }

  getCountryList() {
    debugger;
    this.userService.getCountryList().subscribe(
      (data) => {
        this.countryData = data;
        this.data = this.countryData;
        //console.log("user data" + this.data);
      }
    )
  }

  getLanguageList() {
    debugger;
    this.userService.getLanguageList().subscribe(
      (data) => {
        this.languageData = data;
        this.dataL = this.languageData;
        //console.log("user data" + this.dataL);
      }
    )
  }

  SubmitSearchListForm(form: NgForm) {
    debugger;
    this.isListLoading = true;
    this.roleservice.SearchProjectDetails(this.searchGeneral).subscribe(
      (data: any) => {
        this.isListLoading = false;
        this.projectDetails = data;
        if (this.projectDetails.length === 0) {
          this.showDataBool = false;
          this.setBool = false;
          this.toastr.error("No items found", '', { progressBar: true });
        }
        else {
          this.roleservice.GetCountryLanguageList(this.searchGeneral).subscribe(
            (data: any) => {
              console.log(data);
              this.data = data;
            }
          )
          this.projectid = this.projectDetails[0].projectID;
          this.countryid = this.projectDetails[0].countryID;
          this.langid = this.projectDetails[0].languageID;
          this.vendreg.country = this.projectDetails[0].countryID;
          this.vendreg.country = "";
          this.setBool = true;
          this.singleBool = true;

          this.vendreg.language = this.projectDetails[0].languageID;
          this.vendreg.language = "";
          if (this.projectDetails[0].clintLinkType != undefined && this.projectDetails[0].clintLinkType != null) {
            this.vendreg.single = this.projectDetails[0].clintLinkType.toLowerCase();
          }
          if (this.projectDetails[0].clintLinkType != undefined && this.projectDetails[0].clintLinkType != null) {
            this.vendreg.multiple = this.projectDetails[0].clintLinkType.toLowerCase();
          }
          this.showDataBool = true;
          if (this.projectDetails[0].clintLinkType.toLowerCase() == "single") {
            this.linkBool = true;
            this.uploadFileBool = false;
          }
          else if (this.projectDetails[0].clintLinkType.toLowerCase() == "multiple") {
            this.linkBool = false;
            this.uploadFileBool = true;
          }
          this.textBoxBool = true;
        }
        console.log(this.projectDetails);
      }
    )
  }

  OnSubmit(form: NgForm) {
    this.isLoading = true;
    form.value.langaugeid = this.vendreg.language;
    form.value.countryid = this.vendreg.country;
    form.value.projectid = this.projectid;
    form.value.target = this.target;
    form.value.optimisticcount = this.optimisticcount;
    this.countryid = this.vendreg.country;
    this.langid = this.vendreg.language;
    console.log(form.value);
    if (form.value.set == "single" || this.vendreg.single == "single") {
      form.value.set = "single";
      this.userService.addClientLinkData(form.value)
        .subscribe((data: any) => {
          if (data != null && data != undefined) {
            this.router.navigate(['/assignvendorclip' + "/" + this.projectid + "/" + this.countryid + "/" + this.langid]);
          }
          this.isLoading = false;
        });
    }
    else if (form.value.set == "multiple" || this.vendreg.multiple == "multiple") {
      form.value.set = "multiple";
      form.value.fileName = this.fileName;
      this.userService.addClientLinkDataForMultiple(form.value, this.multipleSurveyLink)
        .subscribe((data: any) => {
          if (data != null && data != undefined) {
            this.router.navigate(['/assignvendorclip' + "/" + this.projectid + "/" + this.countryid + "/" + this.langid + "/" + form.value.set + "/" + this.excelDataNumber]);
            this.isLoading = false;
          }
        });
      // alert("hello world");
    }


  }

  singleChange(event) {
    this.linkBool = true;
    this.uploadFileBool = false;
    this.vendreg.single = "single";
    this.vendreg.multiple = "single";
  }
  multipleChange(event) {
    alert("Message:: Please make sure that the format of excel file should be same as Sample File. \n\n ClientLink:Use this column for client links and sheet name should be kept as 'sheet1'.");
    this.linkBool = false;
    this.uploadFileBool = true;
    this.vendreg.multiple = "multiple";
    this.vendreg.single = "multiple";
  }

  changeCountry(event) {
    this.countryid = this.vendreg.country;
  }
  changeLanguage(event) {
    this.langid = this.vendreg.language
  }
  onFileChange(event): void {
    this.multipleSurveyLink = "";
    this.fileName = event.target.files[0].name;
    this.file = event.target.files[0];
    let fileReader = new FileReader();
    fileReader.readAsArrayBuffer(this.file);
    fileReader.onload = (e) => {
      this.arrayBuffer = fileReader.result;
      var data = new Uint8Array(this.arrayBuffer);
      var arr = new Array();
      for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
      var bstr = arr.join("");
      var workbook = XLSX.read(bstr, { type: "binary" });
      var first_sheet_name = workbook.SheetNames[0];
      var worksheet = workbook.Sheets[first_sheet_name];
      console.log(XLSX.utils.sheet_to_json(worksheet, { raw: true }));
      var arraylist = XLSX.utils.sheet_to_json(worksheet, { raw: true });
      this.filelist = arraylist;
      this.excelDataNumber = arraylist.length;
      console.log(arraylist.length)
      debugger;
      for (var i = 0; i < arraylist.length; i++) {
        this.multipleSurveyLink += arraylist[i]["ClientLink"] + ",";
      }
      if (this.multipleSurveyLink.length > 0) {
        this.multipleSurveyLink = this.multipleSurveyLink.substring(0, this.multipleSurveyLink.length - 1);
        document.getElementById("submitButton").removeAttribute("disabled");
      }

    }
  }
  languageChange(event) {
    debugger;
    //if (this.langid == undefined && this.countryid == undefined) {
      this.userService.GetLangList(this.projectid, this.vendreg.country).subscribe(
        (data: any) => {
          console.log(data);
          this.dataL = data;
        }
      )
    //}
  }
}
